module.exports = __webpack_public_path__ + "img/RIVERse-Exhibition-Mumbai.7483340f.jpg";